import React from "react";
import NumberInput from "../../../../../common/NumberInput";
import Indicator from "../../Indicator";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

class NumeriqueEntier extends React.Component {
  render() {
    const {
      t,
      indicateur,
      onChangeIndicator,
      sousRubriqueIndex,
      libelleEnglobantIndex,
      changeIndicateur,
      valueInputProps,
      computedFields,
      demarche,
    } = this.props;

    const valeurCalculee = (
      <NumberInput
        fullWidth={false}
        style={{ maxWidth: "8rem" }}
        disabled
        value={indicateur.valeurCalculee?.value}
        label={t("hve3a.valeur-mesparcelles", "Valeur MesParcelles")}
        InputProps={valueInputProps}
        className={"mr-2"}
      />
    );

    const valueRendered = (
      <NumberInput
        fullWidth={false}
        value={indicateur.valeur.value ?? ""}
        inputProps={{
          step: 1,
        }}
        style={{ maxWidth: "8rem" }}
        InputLabelProps={{
          style: { fontWeight: indicateur.afficherGras ? "bold" : "normal" },
        }}
        InputProps={valueInputProps}
        disabled={computedFields.includes(indicateur.codeNational)}
        onChange={(newValeur) =>
          changeIndicateur(
            { ...indicateur, valeur: { value: newValeur === "" ? null : Number(newValeur) } },
            sousRubriqueIndex,
            libelleEnglobantIndex
          )
        }
      />
    );

    return (
      <Indicator indicateur={indicateur} onChange={onChangeIndicator} demarche={demarche}>
        {!!indicateur.valeurCalculee && valeurCalculee}
        {valueRendered}
      </Indicator>
    );
  }
}

export default compose(withTranslation())(NumeriqueEntier);
